import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=75acceb5&lang=scss"

const __exports__ = script;

export default __exports__